import MobileDetect from 'mobile-detect';
import detectHover from 'detect-hover';
import ComponentsFactory from './components-factory';
import eventBus from './event-bus';

export const DEVICE_TYPE_DESKTOP_WIDE = 'desktop-wide';
export const DEVICE_TYPE_DESKTOP = 'desktop';
export const DEVICE_TYPE_TABLET = 'tablet';
export const DEVICE_TYPE_MOBILE = 'mobile';

export const EVENT_DEVICE_TYPE_CHANGED = 'device-type-changed';
export const EVENT_RESIZE_FINISHED = 'resize:finished';

const DEBOUNCE_DELAY = 150;
const breakpointsList = [
    {
        name: DEVICE_TYPE_DESKTOP_WIDE,
        value: 1280,
        isMatch: false
    },
    {
        name: DEVICE_TYPE_DESKTOP,
        value: 1024,
        isMatch: false
    },
    {
        name: DEVICE_TYPE_TABLET,
        value: 768,
        isMatch: false
    }
];

class App {
    constructor() {
        this.componentsFactory = ComponentsFactory.getInstance();
        this.config = window.appConfig || {};
        this.state = window.appState || {};
        this.debounceTimeoutId = null;
        this.deviceTypeByViewport = '';

        const md = new MobileDetect(window.navigator.userAgent);

        this.isTouch = (md.mobile() !== null) && !detectHover.anyHover;

        if (this.isTouch) {
            document.documentElement.classList.remove('can-hover');
        }
    }

    init() {
        this.applyViewportData();
        window.addEventListener('resize', this.onWindowResize.bind(this));

        this.componentsFactory.init();
    }

    applyViewportData() {
        let newDeviceTypeByViewport = '';

        this.viewport = {
            width: window.outerWidth,
            height: window.outerHeight
        };

        breakpointsList.forEach((breakpoint) => {
            if (!newDeviceTypeByViewport) {
                newDeviceTypeByViewport = breakpoint.name;
            }
        });

        this.deviceTypeByViewport = newDeviceTypeByViewport || DEVICE_TYPE_MOBILE;
    }

    onWindowResize() {
        if (this.debounceTimeoutId !== null) {
            clearTimeout(this.debounceTimeoutId);
        }

        this.debounceTimeoutId = setTimeout(this.handleWindowResize.bind(this), DEBOUNCE_DELAY);
    }

    handleWindowResize() {
        const oldDeviceType = this.deviceTypeByViewport;

        this.applyViewportData();
        eventBus.emit(EVENT_RESIZE_FINISHED);

        if (oldDeviceType !== this.deviceTypeByViewport) {
            eventBus.emit(EVENT_DEVICE_TYPE_CHANGED, oldDeviceType, this.deviceTypeByViewport);
        }
    }

    getConfig(property, defaultValue = undefined) {
        return property in this.config ? this.config[property] : defaultValue;
    }

    getRequiredConfig(property) {
        if (!(property in this.config)) {
            throw new Error(`cannot find a property «${property}» in config`);
        }
        return this.config[property];
    }

    isDeviceTypeMatch(deviceTypeName) {
        const filteredBreakpoint = breakpointsList.filter(breakpoint =>
            breakpoint.name === deviceTypeName)[0];

        return filteredBreakpoint ? filteredBreakpoint.isMatch : false;
    }
}

const instance = new App();
export default instance;
